import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "avp-head" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "avp-name" }
const _hoisted_4 = { class: "avp-role" }
const _hoisted_5 = { class: "avp-body" }
const _hoisted_6 = {
  key: 0,
  class: "avp-row"
}
const _hoisted_7 = { class: "avp-info" }
const _hoisted_8 = {
  key: 1,
  class: "avp-row avp-row--phone"
}
const _hoisted_9 = { class: "avp-info" }
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 0,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_12 = {
  key: 1,
  width: "10",
  height: "10",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_13 = {
  key: 2,
  class: "avp-row"
}
const _hoisted_14 = { class: "avp-info" }
const _hoisted_15 = {
  key: 3,
  class: "avp-row"
}
const _hoisted_16 = { class: "avp-info" }
const _hoisted_17 = {
  key: 4,
  class: "avp-row"
}
const _hoisted_18 = {
  key: 5,
  class: "avp-row"
}
const _hoisted_19 = { class: "avp-info" }
const _hoisted_20 = {
  key: 6,
  class: "avp-row"
}
const _hoisted_21 = { class: "avp-atend" }
const _hoisted_22 = {
  key: 7,
  class: "avp-row"
}
const _hoisted_23 = { class: "avp-info" }

import { computed, ref } from 'vue'
import type { PopupData } from '@/types/dashboard'
import { avatarColor, initials } from '@/composables/useHelpers'
import { fmtPhone } from '@/utils/contactsFormat'


export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarPopup',
  setup(__props, { expose: __expose }) {

const visible     = ref(false)
const data        = ref<PopupData | null>(null)
const posX        = ref(0)
const posY        = ref(0)
const phoneCopied = ref(false)
let timer: ReturnType<typeof setTimeout> | null = null

const nameColor    = computed(() => avatarColor(data.value?.name || ''))
const nameInitials = computed(() => initials(data.value?.name || ''))
const badgeClass   = computed(() => {
  const s = data.value?.status
  return { online: 'online', offline: 'offline', busy: 'busy' }[s || ''] || 'offline'
})

function show(popupData: PopupData, anchor: HTMLElement) {
  if (timer) clearTimeout(timer)
  data.value    = popupData
  visible.value = true

  const rect = anchor.getBoundingClientRect()
  const pw = 260, ph = 200
  let lx = rect.right + 8, ly = rect.top
  if (lx + pw > window.innerWidth)  lx = rect.left - pw - 8
  if (ly + ph > window.innerHeight) ly = window.innerHeight - ph - 8
  posX.value = lx
  posY.value = Math.max(8, ly)

  const el = document.getElementById('av-popup')
  if (el) { el.style.left = posX.value + 'px'; el.style.top = posY.value + 'px' }
}

function hide(delay = 200) {
  if (timer) clearTimeout(timer)
  timer = setTimeout(() => { visible.value = false }, delay)
}

function cancelHide() {
  if (timer) clearTimeout(timer)
}

async function copyPhone() {
  const phone = data.value?.phone
  if (!phone) return
  await navigator.clipboard.writeText(phone)
  phoneCopied.value = true
  setTimeout(() => { phoneCopied.value = false }, 2000)
}

__expose({ show, hide })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "av-popup",
    class: _normalizeClass({ show: visible.value }),
    onMouseenter: cancelHide,
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (hide(120)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (data.value?.thumbnail)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: data.value.thumbnail,
              alt: data.value.name,
              class: "avp-img",
              onError: _cache[0] || (_cache[0] = (e) => (e.target as HTMLImageElement).style.display='none')
            }, null, 40, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "avp-avatar",
              style: _normalizeStyle({ background: nameColor.value })
            }, _toDisplayString(nameInitials.value), 5))
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(data.value?.name || '—'), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(data.value?.role || data.value?.type || '—'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (data.value?.email)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[2] || (_cache[2] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" }),
              _createElementVNode("polyline", { points: "22,6 12,13 2,6" })
            ], -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(data.value.email), 1)
          ]))
        : _createCommentVNode("", true),
      (data.value?.phone)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[5] || (_cache[5] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.08 4.18 2 2 0 0 1 5.05 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L9.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 23 17z" })
            ], -1)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(fmtPhone)(data.value.phone)), 1),
            _createElementVNode("button", {
              type: "button",
              class: _normalizeClass(["avp-phone-copy", { 'is-copied': phoneCopied.value }]),
              onClick: _withModifiers(copyPhone, ["stop"]),
              title: phoneCopied.value ? 'Copiado!' : 'Copiar número'
            }, [
              (phoneCopied.value)
                ? (_openBlock(), _createElementBlock("svg", _hoisted_11, [...(_cache[3] || (_cache[3] = [
                    _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("rect", {
                      x: "9",
                      y: "9",
                      width: "13",
                      height: "13",
                      rx: "2"
                    }, null, -1),
                    _createElementVNode("path", { d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" }, null, -1)
                  ]))]))
            ], 10, _hoisted_10)
          ]))
        : _createCommentVNode("", true),
      (data.value?.team)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _cache[6] || (_cache[6] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
              _createElementVNode("circle", {
                cx: "9",
                cy: "7",
                r: "4"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(data.value.team), 1)
          ]))
        : _createCommentVNode("", true),
      (data.value?.channel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _cache[7] || (_cache[7] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ], -1)),
            _createElementVNode("span", _hoisted_16, _toDisplayString(data.value.channel), 1)
          ]))
        : _createCommentVNode("", true),
      (data.value?.status !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[8] || (_cache[8] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("circle", {
                cx: "12",
                cy: "12",
                r: "10"
              })
            ], -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["avp-badge", badgeClass.value])
            }, _toDisplayString(data.value.status), 3)
          ]))
        : _createCommentVNode("", true),
      (data.value?.convs !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _cache[9] || (_cache[9] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "18",
                height: "18",
                rx: "2"
              }),
              _createElementVNode("line", {
                x1: "9",
                y1: "9",
                x2: "9",
                y2: "15"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_19, _toDisplayString(data.value.convs) + " conversa(s)", 1)
          ]))
        : _createCommentVNode("", true),
      (data.value?.openConvs && data.value.openConvs > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _cache[10] || (_cache[10] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M3 18v-6a9 9 0 0 1 18 0v6" }),
              _createElementVNode("path", { d: "M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z" })
            ], -1)),
            _createElementVNode("span", _hoisted_21, "em atendimento (" + _toDisplayString(data.value.openConvs) + ")", 1)
          ]))
        : _createCommentVNode("", true),
      (data.value?.labels?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _cache[11] || (_cache[11] = _createElementVNode("svg", {
              class: "avp-icon",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" }),
              _createElementVNode("line", {
                x1: "7",
                y1: "7",
                x2: "7.01",
                y2: "7"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_23, _toDisplayString((data.value.labels || []).map(l => l.replace(/_/g, ' ')).join(', ')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 34))
}
}

})